export default __webpack_public_path__ + "static/media/icon-email.a42dec3c.svg";